import React, { useEffect } from "react";
import "./EditDescriptionModal.scss";
import { Col, Form, Modal, Row } from "antd";
import { formValidation } from "../../../../../utils/formValidation";
import TextArea from "antd/es/input/TextArea";

interface IEditDescriptionModal {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  currentDescription: string;
  onSubmit?: (values: any, afterSubmit?: () => void) => void;
  loading?: boolean;
}

export const EditDescriptionModal: React.FC<IEditDescriptionModal> = ({
  modalOpen,
  setModalOpen,
  currentDescription,
  onSubmit,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!modalOpen) {
      form.resetFields();
    }
  }, [form, modalOpen]);

  useEffect(() => {
    if (modalOpen) {
      form.setFieldsValue({
        description: currentDescription,
      });
    }
  }, [currentDescription, modalOpen]);

  const handleSubmit = (values: any) => {
    onSubmit?.(values, () => setModalOpen(false));
  };

  return (
    <Modal
      open={modalOpen}
      className={"edit-description-modal"}
      title={"აღწერის რედაქტირება"}
      onOk={form.submit}
      okText={"დასტური"}
      cancelText={"დახურვა"}
      onCancel={() => setModalOpen(false)}
      maskClosable
      destroyOnClose
      okButtonProps={{
        loading: loading,
      }}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Row>
          <Col span={24}>
            <Form.Item name={"description"} rules={formValidation.required}>
              <TextArea
                className={"edit-task-textarea"}
                autoSize={false}
                rows={3}
                placeholder={"დავალების აღწერა"}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
